function digitsOnly(value: string): string {
  return value.replaceAll(/\D/g, '')
}

function extractUsNationalDigits(value: string): string {
  let digits = digitsOnly(value)
  if (digits.length >= 11 && digits.startsWith('1')) {
    digits = digits.slice(1)
  }
  return digits.slice(0, 10)
}

/** NANP display — e.g. (415) 555-2148 from E.164 or raw digits. */
export function formatUsNanpDisplay(value: string | null | undefined): string {
  const digits = extractUsNationalDigits(value ?? '')
  if (digits.length !== 10) {
    return value?.trim() ?? ''
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

/** Table / card display — formatted NANP or em dash when empty. */
export function formatUsPhoneCell(value: string | null | undefined): string {
  if (!value?.trim()) return '—'
  const formatted = formatUsNanpDisplay(value)
  return formatted || '—'
}
